import { Text, StackChildren } from '@doordash/design-language'
import { FeatureFlag } from '@doordash/lib-feature-flags'
import { CountryCode } from '@doordash/lib-i18n'
import * as React from 'react'
import { COUNTRY_SHORTCODES } from '../../../constants'

import t from './strings'

type WhatToExpectManagerProps = {
  countryCode: CountryCode
}

export const WhatToExpectManager: React.FC<WhatToExpectManagerProps> = ({
  countryCode,
}) => {
  const isJP = countryCode === COUNTRY_SHORTCODES.JP

  return (
    <React.Fragment>
      <Text styles={Text.Styles.Caps16}>{t.bgTitle()}</Text>
      <StackChildren>
        {!isJP ? (
          <FeatureFlag
            on={() => <Text>• {t.bgStepOne()}</Text>}
            off={() => (
              <Text>
                • {countryCode === 'AU' ? t.bgStepOne() : t.bgStepTwo()}
              </Text>
            )}
            flagName="canadaBgcOutOfBand"
          />
        ) : null}
        <Text>• {t.bgStepThree()}</Text>
        <Text>• {t.bgStepFour()}</Text>
        {!isJP ? <Text>• {t.bgStepFive()}</Text> : null}
      </StackChildren>
    </React.Fragment>
  )
}

export default WhatToExpectManager
